<template>
  <panel :title="product.title">
    <span slot="header-right" class="badge" :class="product.original.status">{{ $t(product.original.status).label }}</span>
    <div class="l-row">
      <div class="l-col-12@md image">
        <img :src="product.variations[0].images[0]" :alt="product.title">
      </div>
    </div>

    <div class="l-row">
      <div class="l-col-12@md">
        <span class="divider">Conta</span>
        <span class="ds-block"><strong>Nome:</strong> {{ account.name }}</span>
        <span class="ds-block"><strong>Nickname:</strong> {{ account.nickname }}</span>
        <span class="divider">Atributos</span>
        <span class="ds-block"><strong>Condição:</strong> {{ $t(`mercadoLivre.conditions.${product.condition}.label`) | attribute }}</span>
        <span class="ds-block"><strong>Marca:</strong> {{ (getAttributeValue('BRAND')) ? getAttributeValue('BRAND') : product.brand | attribute }}</span>
        <span class="ds-block"><strong>Tipo:</strong> {{ $t(`mercadoLivre.types.${product.type}.label`) | attribute }}</span>
        <span class="ds-block"><strong>Envio:</strong> {{ $t(`mercadoLivre.shippingOptions.${product.shippingMode}.label`) | attribute }}</span>
        <span class="ds-block"><strong>Quantidade de variações:</strong> {{ product.variations.length | attribute }}</span>
      </div>
    </div>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      },
      account: {
        type: Object,
        required: false
      }
    },
    methods: {
      getAttributeValue (attributeId) {
        var attributeValue = null
        this.product.attributes.forEach(function (attribute) {
          if (attribute.id === attributeId) {
            attributeValue = attribute.value_name
          }
        })
        return attributeValue
      }
    },
    components: {
      Panel,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .image
    text-align: center

    img
      max-width: 100%
      max-height: 180px

</style>



// WEBPACK FOOTER //
// Product.vue?6bb621f8